export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-force/~/d3-quadtree/src/root.js
// module id = EAWg
// module chunks = 0